import { Input } from 'antd';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import styles from './index.module.scss';

type Props<TFields extends FieldValues> = {
  extraInfo?: string;
  name: Path<TFields>;
  control: Control<TFields>;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
};

const StepInput = <TFields extends FieldValues>({
  extraInfo,
  control,
  name,
  required,
  error,
  disabled,
}: Props<TFields>) => (
  <>
    <div className={styles.inputContainer}>
      <Controller
        rules={{ required }}
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            key={name}
            autoComplete="false"
            {...field}
            status={error ? 'error' : ''}
            disabled={disabled}
          />
        )}
      />
    </div>
    <div className={styles.extraInfo}>{extraInfo}</div>
  </>
);

export default StepInput;
